import { useState, useEffect } from "react";
import { usePymbleApi } from "./usePymbleApi";

// const API_END_POINT = `${api.dtAdmin}/covers/available-teachers`;
const API_END_POINT = "/teacher/admin/available/";

export interface CoverTeacherFilter {
  search?: string;
  active_only?: number;
  type?: string[];
  limit: number;
  page?: number;
  date: string;
}
/**
 * Hook to fetch api data from cover teacher search api
 */
export function useCoverTeacherSearch() {
  const [coverTeacherSearchResult, setCoverTeacherSearchResult] = useState<any>(
    []
  );
  const [coverTeacherResultLoaded, setCoverTeacherSearchResultLoaded] =
    useState(false);
  const [coverTeacherSearchFilter, setCoverTeacherSearchFilter] =
    useState<CoverTeacherFilter>({
      search: "",
      active_only: 1,
      type: ["staff"],
      limit: 10,
      page: 1,
      date: "",
    });

  const { callApiS2: callApi } = usePymbleApi();

  // Load the data
  const getData = async () => {
    setCoverTeacherSearchResultLoaded(false);
    let res = [];
    if (coverTeacherSearchFilter.search) {
      const queryString = getQueryString();
      res = await callApi("GET", API_END_POINT + queryString);
    } else {
      console.log("Note: Must supply a search string");
    }
    processCoverTeacherSearchResult(res);

    setCoverTeacherSearchResultLoaded(true);
  };

  // Construct query string for api query
  const getQueryString = () => {
    let qs = "";
    if (coverTeacherSearchFilter?.date) {
      qs += "date=" + coverTeacherSearchFilter.date + "&";
    }
    if (coverTeacherSearchFilter?.limit) {
      qs += "limit=" + coverTeacherSearchFilter.limit + "&";
    }
    if (coverTeacherSearchFilter?.page) {
      qs += "page=" + coverTeacherSearchFilter.page + "&";
    }
    if (coverTeacherSearchFilter?.search) {
      qs += "search=" + coverTeacherSearchFilter.search + "&";
    }
    if (coverTeacherSearchFilter?.active_only !== undefined) {
      qs += "active_only=" + coverTeacherSearchFilter.active_only + "&";
    }
    if (
      Array.isArray(coverTeacherSearchFilter?.type) &&
      coverTeacherSearchFilter.type.length > 0
    ) {
      for (const t of coverTeacherSearchFilter.type) {
        qs += "type=" + t + "&";
      }
    }
    qs = qs ? "?" + qs : qs;

    return qs;
  };

  const processCoverTeacherSearchResult = (res: any[]) => {
    if (res) {
      let newRes = preProcessResult(res);

      // Sort by name
      // newRes = sortResult(newRes);

      if (newRes) {
        setCoverTeacherSearchResult(newRes);
      }
    }
  };

  // Only sort by name at the moment
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sortResult = (data: any[]) => {
    return data.sort(function (a: any, b: any) {
      try {
        if (a.MemberName && b.MemberName) {
          var nameA = a.MemberName.toUpperCase(); // ignore upper and lowercase
          var nameB = b.MemberName.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        /* squash */
      }
      // names must be equal or documents incorrect
      return 0;
    });
  };

  // Decorate group icon if missing
  const preProcessResult = (data: any) => {
    return data.map((d: any) => {
      // Following fields are for grid display
      d.id = d._id;
      return d;
    });
  };

  const refreshCoverTeacherResult = async () => {
    setCoverTeacherSearchResultLoaded(true);
    await getData();
  };

  // Fires on load of hook
  useEffect(() => {
    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coverTeacherSearchFilter]);

  return {
    coverTeacherSearchResult,
    setCoverTeacherSearchResult,
    coverTeacherResultLoaded,
    refreshCoverTeacherResult,
    coverTeacherSearchFilter,
    setCoverTeacherSearchFilter,
    processCoverTeacherSearchResult,
  };
}
